function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["request", "serial", "className", "columns", "pagination", "resizable", "form", "cacheKey", "toCacheUrl", "isCache", "renderSerial", "search", "actionRef", "formRef", "filterCacheSearchKey", "isCacheSearch", "singleSearchConfig", "resetClearProject", "toolBarRender", "isInitProject", "isPermissionProject"],
  _excluded2 = ["actionRef", "request"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ProTable } from '@ant-design/pro-components';
import './index.less';
import { Empty } from '../Empty';
import { useTableResizable } from './hooks/useTableResizable';
import { freeTablePagination, getFreeTableSearch } from './components';
import { useTableRequestCache } from './hooks/useTableRequestCache';
import { useProjectValue } from './hooks/useProjectValue';
// FreeTable
export var FreeTable = function FreeTable(props) {
  var request = props.request,
    serial = props.serial,
    className = props.className,
    columns = props.columns,
    pagination = props.pagination,
    resizable = props.resizable,
    form = props.form,
    cacheKey = props.cacheKey,
    toCacheUrl = props.toCacheUrl,
    _props$isCache = props.isCache,
    isCache = _props$isCache === void 0 ? false : _props$isCache,
    renderSerial = props.renderSerial,
    search = props.search,
    actionRef = props.actionRef,
    formRef = props.formRef,
    filterCacheSearchKey = props.filterCacheSearchKey,
    isCacheSearch = props.isCacheSearch,
    singleSearchConfig = props.singleSearchConfig,
    _props$resetClearProj = props.resetClearProject,
    resetClearProject = _props$resetClearProj === void 0 ? false : _props$resetClearProj,
    toolBarRender = props.toolBarRender,
    isInitProject = props.isInitProject,
    _props$isPermissionPr = props.isPermissionProject,
    isPermissionProject = _props$isPermissionPr === void 0 ? false : _props$isPermissionPr,
    rest = _objectWithoutProperties(props, _excluded);
  var _useTableRequestCache = useTableRequestCache({
      cacheKey: cacheKey,
      serial: serial,
      isCache: isCache,
      toCacheUrl: toCacheUrl,
      actionRef: actionRef,
      request: request,
      pagination: pagination,
      search: search,
      formRef: formRef,
      filterCacheSearchKey: filterCacheSearchKey,
      isCacheSearch: isCacheSearch
    }),
    tableActionRef = _useTableRequestCache.actionRef,
    handleRequest = _useTableRequestCache.request,
    tableRequestRest = _objectWithoutProperties(_useTableRequestCache, _excluded2);
  var serialSchema = serial === false ? [] : [_objectSpread({
    title: '序号',
    search: false,
    width: 75,
    render: function render(text, record, index, action) {
      var _ref = (tableActionRef === null || tableActionRef === void 0 ? void 0 : tableActionRef.current) || {},
        pageInfo = _ref.pageInfo;
      var _ref2 = pageInfo || {},
        _ref2$current = _ref2.current,
        current = _ref2$current === void 0 ? 1 : _ref2$current,
        _ref2$pageSize = _ref2.pageSize,
        pageSize = _ref2$pageSize === void 0 ? 10 : _ref2$pageSize;
      var t = (current - 1) * pageSize + (index + 1);
      return renderSerial ? renderSerial(t, record, index, action) : t;
    }
  }, serial === true ? {} : serial)];
  var singleColumns = singleSearchConfig ? [{
    dataIndex: singleSearchConfig === null || singleSearchConfig === void 0 ? void 0 : singleSearchConfig.key,
    title: singleSearchConfig === null || singleSearchConfig === void 0 ? void 0 : singleSearchConfig.label,
    hideInTable: true,
    fieldProps: _objectSpread({}, singleSearchConfig === null || singleSearchConfig === void 0 ? void 0 : singleSearchConfig.props)
  }] : [];
  var _useProjectValue = useProjectValue(isInitProject),
    projectInitialValues = _useProjectValue.projectInitialValues;
  var tableResizableProps = useTableResizable({
    resizable: resizable,
    columns: [].concat(serialSchema, singleColumns, _toConsumableArray(columns))
  });
  // const { DEPLOY_TYPE, clearProject } = useJfGlobalProjectStore();
  // const { saveFormProject } = useSaveFormProject();
  // const isCu = DEPLOY_TYPE == 'cu';
  // https://github.com/ant-design/pro-components/issues/56
  // useEffect(() => {
  //   if (form?.initialValues) {
  //     tableRequestRest.formRef.current.setFieldsValue(form?.initialValues || []);
  //   }
  // }, [tableRequestRest.formRef, form?.initialValues]);
  return /*#__PURE__*/React.createElement(ProTable, _objectSpread(_objectSpread(_objectSpread({
    className: className ? "lj-pro-table ".concat(className) : 'lj-pro-table',
    rowKey: "id",
    defaultSize: "large",
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        style: {
          padding: '24px'
        }
      })
    },
    options: false,
    scroll: {
      scrollToFirstRowOnChange: true,
      x: '100%'
    },
    columnEmptyText: '--',
    pagination: pagination === false ? pagination : _objectSpread(_objectSpread({}, freeTablePagination), pagination),
    search: search === false ? false : _objectSpread(_objectSpread({}, getFreeTableSearch(singleSearchConfig ? true : false)), search),
    request: request ? handleRequest : undefined,
    form: _objectSpread(_objectSpread({}, form), {}, {
      initialValues: _objectSpread(_objectSpread({}, form === null || form === void 0 ? void 0 : form.initialValues), projectInitialValues)
    })
  }, tableResizableProps), tableRequestRest), {}, {
    actionRef: tableActionRef,
    toolBarRender: toolBarRender
  }, rest));
};